import React, { useEffect, useState, useRef } from "react";
import * as s from "./styles/globalStyles";
import styled from "styled-components";
import MintWindow from './components/MintWindow';

export const ResponsiveWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: auto;
  height: auto;
  @media (min-width: 780px) {
    width: 130%;
  };
  @media (min-width: 900px) {
    width: 120%;
  };
  @media (min-width: 1280px) {
    width: 100%;
  };
  @media (min-width: 2000px) {
    width: 70%;
  };
`;


function App() {
    const [secondsDiff, setSecondsDiff] = useState(0);
    const [minutesDiff, setMinutesDiff] = useState(0);
    const [hoursDiff, setHoursDiff] = useState(0);
    const [daysDiff, setDaysDiff] = useState(0);
    const [timerEnabled, setTimerEnabled] = useState(false);
    const [timerType, setTimerType] = useState('');

    const [CONFIG, SET_CONFIG] = useState({
      CONTRACT_ADDRESS: "",
      SCAN_LINK: "",
      NETWORK: {
        NAME: "",
        SYMBOL: "",
        ID: 0,
      },
      MINIMUM_PRESALE: 0,
      MAXIMUM_PRESALE: 0,
      DISPLAY_MINIMUM_PRESALE: 0,
      DISPLAY_MAXIMUM_PRESALE: 0,
      GAS_LIMIT: 0,
      SHOW_BACKGROUND: false,
      TWITTER_LINK: '',
    });
  
    const getConfig = async () => {
      const configResponse = await fetch("/config/config.json", {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });
      const config = await configResponse.json();
      SET_CONFIG(config);
    };
  
    useEffect(() => {
      getConfig();
    }, []);

  let start = 1685899800
  let end = 1685943000

  useEffect(() => {
    const interval = setInterval(() => {
      let timeTarget = 0
      if (!timeHasPassed(start)){
        timeTarget = start
        setTimerType("Starts in")
        setTimerEnabled(true)
      } else if (!timeHasPassed(end)){
        timeTarget = end
        setTimerType("Finishes in")
        setTimerEnabled(true)
      } else {
        setTimerEnabled(false)
        return
      }

      var res = Math.abs(timeTarget - parseInt(Math.floor(Date.now() / 1000)));

      setDaysDiff(Math.floor(res / 86400))      
      setHoursDiff(Math.floor(res / 3600) % 24)
      setMinutesDiff( Math.floor(res / 60) % 60)
      setSecondsDiff(res % 60)

      // console.log('difference = ' +
      //   daysDiff + ' day/s ' +
      //   hoursDiff + ' hour/s ' +
      //   minutesDiff + ' minute/s ' +
      //   secondsDiff + ' second/s ');

    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <s.Screen>
    {/* <s.Screen image={"/config/images/shlong.png"}> */}
        <ResponsiveWrapper>
        <s.ImageWrapper src={`./config/images/gif.gif`} width="25%" height="auto"/>
          <s.SpacerLarge/>
          <MintWindow 
            secondsDiff={secondsDiff}
            minutesDiff={minutesDiff}
            hoursDiff={hoursDiff}
            daysDiff={daysDiff}
            timerEnabled={timerEnabled}
            timerType={timerType}
          />
          <s.SpacerLarge/>
          <s.ImageWrapper src={`./config/images/gif.gif`} width="25%" height="auto"/>
        </ResponsiveWrapper>
    </s.Screen>
  );
}

const timeHasPassed = (startTime) => {
  let now = Math.floor(Date.now() / 1000)
  return parseInt(startTime) < now
}

export default App;
